// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SectionAside-module__font-s-10___zE8jY {
  font-size: 10px !important;
}

.SectionAside-module__font-s-12___H13IU {
  font-size: 12px !important;
}

.SectionAside-module__font-s-13___l14v7 {
  font-size: 13px !important;
}

.SectionAside-module__font-s-14___q0YAR {
  font-size: 14px !important;
}

.SectionAside-module__font-s-15___vvB1J {
  font-size: 15px !important;
}

.SectionAside-module__font-s-16___p1RTD {
  font-size: 16px !important;
}

.SectionAside-module__font-s-18___jOr0e {
  font-size: 18px !important;
}

.SectionAside-module__font-s-20___bYZ_w {
  font-size: 20px !important;
}

.SectionAside-module__font-s-22___Mha6L {
  font-size: 22px !important;
}

.SectionAside-module__font-s-28___XdTG4 {
  font-size: 28px !important;
}

.SectionAside-module__font-w-400___zfPsv {
  font-weight: 400 !important;
}

.SectionAside-module__font-w-500___a9L8C {
  font-weight: 500 !important;
}

.SectionAside-module__font-w-600___HyyVs {
  font-weight: 600 !important;
}

.SectionAside-module__font-w-700___LKsiV {
  font-weight: 700 !important;
}

.SectionAside-module__p-5___VePlE {
  padding: 5px !important;
}

.SectionAside-module__p-12___E5RVx {
  padding: 12px !important;
}

.SectionAside-module__p-16___vuurt {
  padding: 16px !important;
}

.SectionAside-module__p-30___v90Fd {
  padding: 30px !important;
}

.SectionAside-module__p-b-0___Ip_TO {
  padding-bottom: 0 !important;
}

.SectionAside-module__p-b-5___mU_z1 {
  padding-bottom: 5px !important;
}

.SectionAside-module__p-b-10___GInQo {
  padding-bottom: 10px !important;
}

.SectionAside-module__p-b-12___hpdlH {
  padding-bottom: 12px !important;
}

.SectionAside-module__p-b-16___ocOUV {
  padding-bottom: 16px !important;
}

.SectionAside-module__p-b-18___qO2rK {
  padding-bottom: 18px !important;
}

.SectionAside-module__p-b-20___KSVrw {
  padding-bottom: 20px !important;
}

.SectionAside-module__p-b-25___wfOAf {
  padding-bottom: 25px !important;
}

.SectionAside-module__p-b-30___TEaBH {
  padding-bottom: 30px !important;
}

.SectionAside-module__p-b-50___aKyV6 {
  padding-bottom: 50px !important;
}

.SectionAside-module__p-t-0___Wpept {
  padding-top: 0 !important;
}

.SectionAside-module__p-t-12___nnGD_ {
  padding-top: 12px !important;
}

.SectionAside-module__p-t-16___jeJjj {
  padding-top: 16px !important;
}

.SectionAside-module__p-t-18___Jm3_O {
  padding-top: 18px !important;
}

.SectionAside-module__p-t-20___EmY0T {
  padding-top: 20px !important;
}

.SectionAside-module__p-t-30___AeNfD {
  padding-top: 30px !important;
}

.SectionAside-module__p-t-40___z1IYt {
  padding-top: 40px !important;
}

.SectionAside-module__p-t-50___X6sIT {
  padding-top: 50px !important;
}

.SectionAside-module__p-l-20___tYMXT {
  padding-left: 20px !important;
}

.SectionAside-module__p-l-30___rPyhK {
  padding-left: 30px !important;
}

.SectionAside-module__p-l-40___MH_HV {
  padding-left: 40px !important;
}

.SectionAside-module__p-r-16___uWyG3 {
  padding-right: 16px !important;
}

.SectionAside-module__p-r-20___pxY8D {
  padding-right: 20px !important;
}

.SectionAside-module__p-r-30___n6AjA {
  padding-right: 30px !important;
}

.SectionAside-module__p-r-50___urb0r {
  padding-right: 50px !important;
}

.SectionAside-module__p-r-60___d6lst {
  padding-right: 60px !important;
}

.SectionAside-module__m-b-1___kjpbA {
  margin-bottom: 1px !important;
}

.SectionAside-module__m-b-2___AcqKC {
  margin-bottom: 2px !important;
}

.SectionAside-module__m-b-6___IFQMM {
  margin-bottom: 6px !important;
}

.SectionAside-module__m-b-8___zkjbz {
  margin-bottom: 8px !important;
}

.SectionAside-module__m-b-10___KopJo {
  margin-bottom: 10px !important;
}

.SectionAside-module__m-b-14___gz1i4 {
  margin-bottom: 14px !important;
}

.SectionAside-module__m-b-16___y68Ep {
  margin-bottom: 16px !important;
}

.SectionAside-module__m-b-20___gCNjh {
  margin-bottom: 20px !important;
}

.SectionAside-module__m-b-22___zYUsN {
  margin-bottom: 22px !important;
}

.SectionAside-module__m-b-24___ruk6l {
  margin-bottom: 24px !important;
}

.SectionAside-module__m-b-30___A2uCI {
  margin-bottom: 30px !important;
}

.SectionAside-module__m-b-32___wuzPY {
  margin-bottom: 32px !important;
}

.SectionAside-module__m-b-40___hhAtV {
  margin-bottom: 40px !important;
}

.SectionAside-module__m-t-2___YlccK {
  margin-top: 2px !important;
}

.SectionAside-module__m-t-3___F2PgK {
  margin-top: 3px !important;
}

.SectionAside-module__m-t-4___fghDl {
  margin-top: 4px !important;
}

.SectionAside-module__m-t-5___qFFLB {
  margin-top: 5px !important;
}

.SectionAside-module__m-t-8___TPNaK {
  margin-top: 8px !important;
}

.SectionAside-module__m-t-10___UADNm {
  margin-top: 10px !important;
}

.SectionAside-module__m-t-15___ZCv6x {
  margin-top: 15px !important;
}

.SectionAside-module__m-t-16___ILNvn {
  margin-top: 16px !important;
}

.SectionAside-module__m-t-20___dNn8d {
  margin-top: 20px !important;
}

.SectionAside-module__m-t-22___TLqAa {
  margin-top: 22px !important;
}

.SectionAside-module__m-t-30___YkpLQ {
  margin-top: 30px !important;
}

.SectionAside-module__m-t-32___EFC6s {
  margin-top: 32px !important;
}

.SectionAside-module__m-l-auto___rRqyg {
  margin-left: auto !important;
}

.SectionAside-module__m-l-4___zawGg {
  margin-left: 4px !important;
}

.SectionAside-module__m-l-5___cq3uz {
  margin-left: 5px !important;
}

.SectionAside-module__m-l-6___lhYEL {
  margin-left: 6px !important;
}

.SectionAside-module__m-l-8___IuXps {
  margin-left: 8px !important;
}

.SectionAside-module__m-l-10___eEHgJ {
  margin-left: 10px !important;
}

.SectionAside-module__m-l-16___yYw8g {
  margin-left: 16px !important;
}

.SectionAside-module__m-l-20___BabhT {
  margin-left: 20px !important;
}

.SectionAside-module__m-l-24___R6b4d {
  margin-left: 24px !important;
}

.SectionAside-module__m-l-30___BYFGZ {
  margin-left: 30px !important;
}

.SectionAside-module__m-l-35___EJGNu {
  margin-left: 35px !important;
}

.SectionAside-module__m-l-40___U_vdu {
  margin-left: 40px !important;
}

.SectionAside-module__m-r-8___LuJu2 {
  margin-right: 8px !important;
}

.SectionAside-module__m-r-10___dyuy8 {
  margin-right: 10px !important;
}

.SectionAside-module__m-r-16___uyHJK {
  margin-right: 16px !important;
}

.SectionAside-module__m-r-20___kC0kj {
  margin-right: 20px !important;
}

.SectionAside-module__m-r-24___nyOfG {
  margin-right: 24px !important;
}

.SectionAside-module__m-r-30___JbnWo {
  margin-right: 30px !important;
}

.SectionAside-module__m-r-40___Ttnb0 {
  margin-right: 40px !important;
}

.SectionAside-module__border-r-3___G769t {
  border-radius: 3px !important;
}

.SectionAside-module__border-r-4____sQut {
  border-radius: 4px !important;
}

.SectionAside-module__border-r-6___dgE4G {
  border-radius: 6px !important;
}

.SectionAside-module__border-r-10___r3neI {
  border-radius: 10px !important;
}

.SectionAside-module__border-r-12____96NL {
  border-radius: 12px !important;
}

.SectionAside-module__border-r-16___hHn3Q {
  border-radius: 16px !important;
}

.SectionAside-module__border-r-50___L0gRs {
  border-radius: 50% !important;
}

.SectionAside-module__primary-border___WTIlB {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.SectionAside-module__primary-border-b___oE_gK {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.SectionAside-module__primary-border-t___V1nPw {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.SectionAside-module__primary-border-l___MvVFG {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.SectionAside-module__primary-border-r___QcqdZ {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.SectionAside-module__secondary-border___aTt6J {
  border: 1px solid #637768;
}

.SectionAside-module__secondary-border-b___lDwwu {
  border-bottom: 1px solid #637768;
}

.SectionAside-module__secondary-border-t___LAucR {
  border-top: 1px solid #637768;
}

.SectionAside-module__secondary-border-l___FshP1 {
  border-left: 1px solid #637768;
}

.SectionAside-module__secondary-border-r___dMDND {
  border-right: 1px solid #637768;
}

.SectionAside-module__gap-0___KmzSz {
  gap: 0 !important;
}

.SectionAside-module__gap-2___qIV3w {
  gap: 2px !important;
}

.SectionAside-module__gap-4___fec7R {
  gap: 4px !important;
}

.SectionAside-module__gap-5___NKbyT {
  gap: 5px !important;
}

.SectionAside-module__gap-6___PwbcW {
  gap: 6px !important;
}

.SectionAside-module__gap-8___P1pts {
  gap: 8px !important;
}

.SectionAside-module__gap-10___rRKvm {
  gap: 10px !important;
}

.SectionAside-module__gap-12___YzKN4 {
  gap: 12px !important;
}

.SectionAside-module__gap-14___cR4YE {
  gap: 14px !important;
}

.SectionAside-module__gap-16___Ixh6h {
  gap: 16px !important;
}

.SectionAside-module__gap-18___f4EHk {
  gap: 18px !important;
}

.SectionAside-module__gap-20___tCNM9 {
  gap: 20px !important;
}

.SectionAside-module__gap-24___cMgAh {
  gap: 24px !important;
}

.SectionAside-module__gap-26___u9eBT {
  gap: 26px !important;
}

.SectionAside-module__gap-30___yVgQC {
  gap: 30px !important;
}

.SectionAside-module__gap-32___UlPys {
  gap: 32px !important;
}

.SectionAside-module__gap-40___lYeE4 {
  gap: 40px !important;
}

.SectionAside-module__gap-50___zPPgc {
  gap: 50px !important;
}

.SectionAside-module__flex-1___AnRL4 {
  flex: 1;
}

.SectionAside-module__flex-none___NyVSf {
  flex: none !important;
}

.SectionAside-module__flex-column___lmQL_ {
  display: flex;
  flex-direction: column !important;
}

.SectionAside-module__flex-row___qlc5J {
  display: flex;
  flex-direction: row !important;
}

.SectionAside-module__vertically-centered___mSE0w {
  display: flex;
  align-items: center !important;
}

.SectionAside-module__horizontally-centered___oteva {
  display: flex;
  justify-content: center !important;
}

.SectionAside-module__horizontally-end___KkgPW {
  display: flex;
  justify-content: end !important;
}

.SectionAside-module__vertically-start___ZWpbB {
  display: flex;
  align-items: start !important;
}

.SectionAside-module__space-between___bXGDx {
  display: flex;
  justify-content: space-between !important;
}

.SectionAside-module__flex-wrap___wnTFx {
  flex-wrap: wrap !important;
}

.SectionAside-module__height-100___biaDa {
  height: 100%;
}

.SectionAside-module__width-50___lqfD3 {
  width: 50% !important;
}

.SectionAside-module__width-100___CpHmg {
  width: 100%;
}

.SectionAside-module__cursor-pointer___aS4en {
  cursor: pointer;
}

.SectionAside-module__cursor-not-allowed___aijHk {
  cursor: not-allowed !important;
}

.SectionAside-module__absolute-centered___MIl7W {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.SectionAside-module__absolute___BDDfq {
  position: absolute;
}

.SectionAside-module__relative___QVSJB {
  position: relative;
}

.SectionAside-module__fixed___IKsMK {
  position: fixed;
}

.SectionAside-module__visible___Ttzn8 {
  opacity: 1;
}

.SectionAside-module__invisible___I6KbM {
  opacity: 0;
}

.SectionAside-module__col-90___iLdEl {
  width: 90% !important;
}

.SectionAside-module__col-auto___jPtUZ {
  width: auto !important;
}

.SectionAside-module__medical-tabs___lB44B {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.SectionAside-module__medical-table-new___NYppc {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SectionAside-module__medical-table-new___NYppc:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SectionAside-module__medical-table-new___NYppc::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SectionAside-module__medical-table-new___NYppc::-webkit-scrollbar-track {
  display: none;
}
.SectionAside-module__medical-table-new___NYppc.SectionAside-module__no-pagination___WCVYk {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SectionAside-module__medical-table-new___NYppc.SectionAside-module__no-pagination___WCVYk:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SectionAside-module__medical-table-new___NYppc.SectionAside-module__no-pagination___WCVYk::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SectionAside-module__medical-table-new___NYppc.SectionAside-module__no-pagination___WCVYk::-webkit-scrollbar-track {
  display: none;
}

.SectionAside-module__medical-table-empty___ObtzO {
  padding: 14px 40px !important;
}

.SectionAside-module__icon-btn___rBYp_ {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.SectionAside-module__search-icon___TbkZ3 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.SectionAside-module__disable-select___BAjJ0 {
  user-select: none;
}

.SectionAside-module__break-word___Lm8Ho {
  word-break: break-word;
}

.SectionAside-module__popup-clear-btn___MM3j0 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.SectionAside-module__scroll-m-b-20___sLwFz {
  scroll-margin-bottom: 20px;
}

.SectionAside-module__aside___jV8H2 {
  background: rgba(251, 247, 242, 0.5);
  overflow-y: scroll;
  width: 360px;
  height: calc(100vh - 100px - var(--top-navigation) - var(--patient-details-header) - var(--patient-details-footer));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SectionAside-module__aside___jV8H2:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SectionAside-module__aside___jV8H2::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SectionAside-module__aside___jV8H2::-webkit-scrollbar-track {
  display: none;
}
.SectionAside-module__aside___jV8H2 .SectionAside-module__description___h13yx {
  color: #859989;
  text-wrap: balance;
  padding: 0 20px;
}
.SectionAside-module__aside___jV8H2 .SectionAside-module__header___y8bv5 {
  color: #375844;
  margin: 20px 0 10px 0;
}
.SectionAside-module__aside___jV8H2 .SectionAside-module__header___y8bv5::first-letter {
  text-transform: capitalize;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/DocumentationIndex/components/SectionAside/SectionAside.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,oCAAA;EACA,kBAAA;EACA,YAAA;ECKA,mHDHE;ECIF,kBAAA;EACA,kBAAA;AD0pBF;ACxpBE;EACE,oCAAA;EACA,mBAAA;AD0pBJ;ACvpBE;EACE,UAAA;EACA,6BAAA;ADypBJ;ACtpBE;EACE,aAAA;ADwpBJ;AAnqBE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;AAqqBJ;AAlqBE;EACE,cAAA;EACA,qBAAA;AAoqBJ;AAlqBI;EACE,0BAAA;AAoqBN","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.aside {\n  background: rgba(251, 247, 242, 0.5);\n  overflow-y: scroll;\n  width: 360px;\n  @include verticalScroll(\n    calc(\n      100vh - 100px - var(--top-navigation) - var(--patient-details-header) - var(\n          --patient-details-footer\n        )\n    )\n  );\n\n  .description {\n    color: get-color(greenNew, medium);\n    text-wrap: balance;\n    padding: 0 20px;\n  }\n\n  .header {\n    color: get-color(greenNew, dark);\n    margin: 20px 0 10px 0;\n\n    &::first-letter {\n      text-transform: capitalize;\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `SectionAside-module__font-s-10___zE8jY`,
	"fontS12": `SectionAside-module__font-s-12___H13IU`,
	"fontS13": `SectionAside-module__font-s-13___l14v7`,
	"fontS14": `SectionAside-module__font-s-14___q0YAR`,
	"fontS15": `SectionAside-module__font-s-15___vvB1J`,
	"fontS16": `SectionAside-module__font-s-16___p1RTD`,
	"fontS18": `SectionAside-module__font-s-18___jOr0e`,
	"fontS20": `SectionAside-module__font-s-20___bYZ_w`,
	"fontS22": `SectionAside-module__font-s-22___Mha6L`,
	"fontS28": `SectionAside-module__font-s-28___XdTG4`,
	"fontW400": `SectionAside-module__font-w-400___zfPsv`,
	"fontW500": `SectionAside-module__font-w-500___a9L8C`,
	"fontW600": `SectionAside-module__font-w-600___HyyVs`,
	"fontW700": `SectionAside-module__font-w-700___LKsiV`,
	"p5": `SectionAside-module__p-5___VePlE`,
	"p12": `SectionAside-module__p-12___E5RVx`,
	"p16": `SectionAside-module__p-16___vuurt`,
	"p30": `SectionAside-module__p-30___v90Fd`,
	"pB0": `SectionAside-module__p-b-0___Ip_TO`,
	"pB5": `SectionAside-module__p-b-5___mU_z1`,
	"pB10": `SectionAside-module__p-b-10___GInQo`,
	"pB12": `SectionAside-module__p-b-12___hpdlH`,
	"pB16": `SectionAside-module__p-b-16___ocOUV`,
	"pB18": `SectionAside-module__p-b-18___qO2rK`,
	"pB20": `SectionAside-module__p-b-20___KSVrw`,
	"pB25": `SectionAside-module__p-b-25___wfOAf`,
	"pB30": `SectionAside-module__p-b-30___TEaBH`,
	"pB50": `SectionAside-module__p-b-50___aKyV6`,
	"pT0": `SectionAside-module__p-t-0___Wpept`,
	"pT12": `SectionAside-module__p-t-12___nnGD_`,
	"pT16": `SectionAside-module__p-t-16___jeJjj`,
	"pT18": `SectionAside-module__p-t-18___Jm3_O`,
	"pT20": `SectionAside-module__p-t-20___EmY0T`,
	"pT30": `SectionAside-module__p-t-30___AeNfD`,
	"pT40": `SectionAside-module__p-t-40___z1IYt`,
	"pT50": `SectionAside-module__p-t-50___X6sIT`,
	"pL20": `SectionAside-module__p-l-20___tYMXT`,
	"pL30": `SectionAside-module__p-l-30___rPyhK`,
	"pL40": `SectionAside-module__p-l-40___MH_HV`,
	"pR16": `SectionAside-module__p-r-16___uWyG3`,
	"pR20": `SectionAside-module__p-r-20___pxY8D`,
	"pR30": `SectionAside-module__p-r-30___n6AjA`,
	"pR50": `SectionAside-module__p-r-50___urb0r`,
	"pR60": `SectionAside-module__p-r-60___d6lst`,
	"mB1": `SectionAside-module__m-b-1___kjpbA`,
	"mB2": `SectionAside-module__m-b-2___AcqKC`,
	"mB6": `SectionAside-module__m-b-6___IFQMM`,
	"mB8": `SectionAside-module__m-b-8___zkjbz`,
	"mB10": `SectionAside-module__m-b-10___KopJo`,
	"mB14": `SectionAside-module__m-b-14___gz1i4`,
	"mB16": `SectionAside-module__m-b-16___y68Ep`,
	"mB20": `SectionAside-module__m-b-20___gCNjh`,
	"mB22": `SectionAside-module__m-b-22___zYUsN`,
	"mB24": `SectionAside-module__m-b-24___ruk6l`,
	"mB30": `SectionAside-module__m-b-30___A2uCI`,
	"mB32": `SectionAside-module__m-b-32___wuzPY`,
	"mB40": `SectionAside-module__m-b-40___hhAtV`,
	"mT2": `SectionAside-module__m-t-2___YlccK`,
	"mT3": `SectionAside-module__m-t-3___F2PgK`,
	"mT4": `SectionAside-module__m-t-4___fghDl`,
	"mT5": `SectionAside-module__m-t-5___qFFLB`,
	"mT8": `SectionAside-module__m-t-8___TPNaK`,
	"mT10": `SectionAside-module__m-t-10___UADNm`,
	"mT15": `SectionAside-module__m-t-15___ZCv6x`,
	"mT16": `SectionAside-module__m-t-16___ILNvn`,
	"mT20": `SectionAside-module__m-t-20___dNn8d`,
	"mT22": `SectionAside-module__m-t-22___TLqAa`,
	"mT30": `SectionAside-module__m-t-30___YkpLQ`,
	"mT32": `SectionAside-module__m-t-32___EFC6s`,
	"mLAuto": `SectionAside-module__m-l-auto___rRqyg`,
	"mL4": `SectionAside-module__m-l-4___zawGg`,
	"mL5": `SectionAside-module__m-l-5___cq3uz`,
	"mL6": `SectionAside-module__m-l-6___lhYEL`,
	"mL8": `SectionAside-module__m-l-8___IuXps`,
	"mL10": `SectionAside-module__m-l-10___eEHgJ`,
	"mL16": `SectionAside-module__m-l-16___yYw8g`,
	"mL20": `SectionAside-module__m-l-20___BabhT`,
	"mL24": `SectionAside-module__m-l-24___R6b4d`,
	"mL30": `SectionAside-module__m-l-30___BYFGZ`,
	"mL35": `SectionAside-module__m-l-35___EJGNu`,
	"mL40": `SectionAside-module__m-l-40___U_vdu`,
	"mR8": `SectionAside-module__m-r-8___LuJu2`,
	"mR10": `SectionAside-module__m-r-10___dyuy8`,
	"mR16": `SectionAside-module__m-r-16___uyHJK`,
	"mR20": `SectionAside-module__m-r-20___kC0kj`,
	"mR24": `SectionAside-module__m-r-24___nyOfG`,
	"mR30": `SectionAside-module__m-r-30___JbnWo`,
	"mR40": `SectionAside-module__m-r-40___Ttnb0`,
	"borderR3": `SectionAside-module__border-r-3___G769t`,
	"borderR4": `SectionAside-module__border-r-4____sQut`,
	"borderR6": `SectionAside-module__border-r-6___dgE4G`,
	"borderR10": `SectionAside-module__border-r-10___r3neI`,
	"borderR12": `SectionAside-module__border-r-12____96NL`,
	"borderR16": `SectionAside-module__border-r-16___hHn3Q`,
	"borderR50": `SectionAside-module__border-r-50___L0gRs`,
	"primaryBorder": `SectionAside-module__primary-border___WTIlB`,
	"primaryBorderB": `SectionAside-module__primary-border-b___oE_gK`,
	"primaryBorderT": `SectionAside-module__primary-border-t___V1nPw`,
	"primaryBorderL": `SectionAside-module__primary-border-l___MvVFG`,
	"primaryBorderR": `SectionAside-module__primary-border-r___QcqdZ`,
	"secondaryBorder": `SectionAside-module__secondary-border___aTt6J`,
	"secondaryBorderB": `SectionAside-module__secondary-border-b___lDwwu`,
	"secondaryBorderT": `SectionAside-module__secondary-border-t___LAucR`,
	"secondaryBorderL": `SectionAside-module__secondary-border-l___FshP1`,
	"secondaryBorderR": `SectionAside-module__secondary-border-r___dMDND`,
	"gap0": `SectionAside-module__gap-0___KmzSz`,
	"gap2": `SectionAside-module__gap-2___qIV3w`,
	"gap4": `SectionAside-module__gap-4___fec7R`,
	"gap5": `SectionAside-module__gap-5___NKbyT`,
	"gap6": `SectionAside-module__gap-6___PwbcW`,
	"gap8": `SectionAside-module__gap-8___P1pts`,
	"gap10": `SectionAside-module__gap-10___rRKvm`,
	"gap12": `SectionAside-module__gap-12___YzKN4`,
	"gap14": `SectionAside-module__gap-14___cR4YE`,
	"gap16": `SectionAside-module__gap-16___Ixh6h`,
	"gap18": `SectionAside-module__gap-18___f4EHk`,
	"gap20": `SectionAside-module__gap-20___tCNM9`,
	"gap24": `SectionAside-module__gap-24___cMgAh`,
	"gap26": `SectionAside-module__gap-26___u9eBT`,
	"gap30": `SectionAside-module__gap-30___yVgQC`,
	"gap32": `SectionAside-module__gap-32___UlPys`,
	"gap40": `SectionAside-module__gap-40___lYeE4`,
	"gap50": `SectionAside-module__gap-50___zPPgc`,
	"flex1": `SectionAside-module__flex-1___AnRL4`,
	"flexNone": `SectionAside-module__flex-none___NyVSf`,
	"flexColumn": `SectionAside-module__flex-column___lmQL_`,
	"flexRow": `SectionAside-module__flex-row___qlc5J`,
	"verticallyCentered": `SectionAside-module__vertically-centered___mSE0w`,
	"horizontallyCentered": `SectionAside-module__horizontally-centered___oteva`,
	"horizontallyEnd": `SectionAside-module__horizontally-end___KkgPW`,
	"verticallyStart": `SectionAside-module__vertically-start___ZWpbB`,
	"spaceBetween": `SectionAside-module__space-between___bXGDx`,
	"flexWrap": `SectionAside-module__flex-wrap___wnTFx`,
	"height100": `SectionAside-module__height-100___biaDa`,
	"width50": `SectionAside-module__width-50___lqfD3`,
	"width100": `SectionAside-module__width-100___CpHmg`,
	"cursorPointer": `SectionAside-module__cursor-pointer___aS4en`,
	"cursorNotAllowed": `SectionAside-module__cursor-not-allowed___aijHk`,
	"absoluteCentered": `SectionAside-module__absolute-centered___MIl7W`,
	"absolute": `SectionAside-module__absolute___BDDfq`,
	"relative": `SectionAside-module__relative___QVSJB`,
	"fixed": `SectionAside-module__fixed___IKsMK`,
	"visible": `SectionAside-module__visible___Ttzn8`,
	"invisible": `SectionAside-module__invisible___I6KbM`,
	"col90": `SectionAside-module__col-90___iLdEl`,
	"colAuto": `SectionAside-module__col-auto___jPtUZ`,
	"medicalTabs": `SectionAside-module__medical-tabs___lB44B`,
	"medicalTableNew": `SectionAside-module__medical-table-new___NYppc`,
	"noPagination": `SectionAside-module__no-pagination___WCVYk`,
	"medicalTableEmpty": `SectionAside-module__medical-table-empty___ObtzO`,
	"iconBtn": `SectionAside-module__icon-btn___rBYp_`,
	"searchIcon": `SectionAside-module__search-icon___TbkZ3`,
	"disableSelect": `SectionAside-module__disable-select___BAjJ0`,
	"breakWord": `SectionAside-module__break-word___Lm8Ho`,
	"popupClearBtn": `SectionAside-module__popup-clear-btn___MM3j0`,
	"scrollMB20": `SectionAside-module__scroll-m-b-20___sLwFz`,
	"aside": `SectionAside-module__aside___jV8H2`,
	"description": `SectionAside-module__description___h13yx`,
	"header": `SectionAside-module__header___y8bv5`
};
module.exports = ___CSS_LOADER_EXPORT___;
